export const OpenModalIcon = (props: any) => (
  <div {...props}>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 25.8C20.0693 25.8 25.8 20.0693 25.8 13C25.8 5.93077 20.0693 0.200012 13 0.200012C5.93076 0.200012 0.200005 5.93077 0.200005 13C0.200005 20.0693 5.93076 25.8 13 25.8ZM14.6 8.20001C14.6 7.31636 13.8837 6.60001 13 6.60001C12.1163 6.60001 11.4 7.31636 11.4 8.20001V11.4H8.2C7.31635 11.4 6.6 12.1164 6.6 13C6.6 13.8837 7.31635 14.6 8.2 14.6H11.4V17.8C11.4 18.6837 12.1163 19.4 13 19.4C13.8837 19.4 14.6 18.6837 14.6 17.8V14.6H17.8C18.6837 14.6 19.4 13.8837 19.4 13C19.4 12.1164 18.6837 11.4 17.8 11.4H14.6V8.20001Z"
        fill="#615EF0"
      />
    </svg>
  </div>
);
